module.exports = __webpack_public_path__ + "img/i04.c5f52d5f.svg";